import React from 'react'

import {
  HOMEPAGE_FIELDS,
  LOCAL_BUSINESS_FIELDS,
  PAGE_META_FIELDS,
} from '../../constants/fieldGroups.constant'
import AbstractDocument from '../Abstract/AbstractDocument'

// Phase 6 — single-doc editor for one FAQ Q&A pair. Question = Name /
// Name Ar, answer = Content / Content Ar (Quill), display sequence = Order.
// Slide fields are listed individually because SLIDE_FIELDS includes
// `order`, which FAQs DO need.
const Faq = function () {
  return (
    <AbstractDocument
      singleCollectionName="Faq"
      notToShow={[
        'ancestorIds',
        'parentId',
        'type',
        'featured',
        'coverPhoto',
        'coverImageAlt',
        'coverImageAltAr',
        'images',
        'videos',
        'title',
        'titleAr',
        'publishedAt',
        'scheduledFor',
        'heading',
        'headingAr',
        'subheading',
        'subheadingAr',
        'ctaLabel',
        'ctaLabelAr',
        'ctaUrl',
        ...PAGE_META_FIELDS,
        ...HOMEPAGE_FIELDS,
        ...LOCAL_BUSINESS_FIELDS,
      ]}
    />
  )
}
export default Faq
